module.exports = __webpack_public_path__ + "d21610f476da3e3499c2fb3ca4bdab6d.png";


//////////////////
// WEBPACK FOOTER
// ./app/images/payment-methods-final.png
// module id = ./app/images/payment-methods-final.png
// module chunks = 40